import React, { useEffect } from 'react';
import { mapModifiers } from 'libs/component';
import { ScrollFreezer } from 'libs/scroll-freezer';
import { Icon } from 'components/atoms/icon';

export interface ModalProps {
  children?: React.ReactNode;
  opened?: boolean;
  onCloseRequested?: () => void;
  id?: string;
  className?: string;
  noCloseButton?: boolean;
  noHeader?: boolean;
  noBackground?: boolean;
}

export const Modal: React.FC<ModalProps> = ({
  children,
  opened,
  onCloseRequested,
  id,
  className: additionalClassName = '',
  noCloseButton,
  noHeader,
  noBackground,
}) => {
  const componentClassName = mapModifiers('o-modal', opened && 'opened', noBackground && 'no-background');
  const className = `${componentClassName} ${additionalClassName}`.trim();

  useEffect(() => {
    if (!opened) {
      ScrollFreezer.unfreeze();
      return () => undefined;
    }

    const prevRestoration = 'scrollRestoration' in history ? history.scrollRestoration : undefined;
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    // 先回到顶部再锁定滚动，避免恢复滚动位置后 freeze 造成跳动
    window.scrollTo(0, 0);
    ScrollFreezer.freeze();

    return () => {
      ScrollFreezer.unfreeze();
      if (prevRestoration && 'scrollRestoration' in history) {
        history.scrollRestoration = prevRestoration;
      }
    };
  }, [opened]);

  return (
    <div className={className} id={id}>
      <div className="o-modal__window">
        {!noHeader && (
          <header className="o-modal__header">
            {!noCloseButton && (
              <button className="o-modal__close-button" type="button" onClick={onCloseRequested}>
                <Icon name="close" />
              </button>
            )}
          </header>
        )}
        <main className="o-modal__body">{children}</main>
      </div>
    </div>
  );
};
